import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.CHIP}/v3/suppliers`;

async function create(payload) {
	try {
		const requestPayload = {
			SupplierName: payload?.supplierName ?? payload?.SupplierName ?? "",
			CommercialContactName:
				payload?.commercialContactName ?? payload?.CommercialContactName ?? "",
			CommercialPhone:
				payload?.commercialPhone ?? payload?.CommercialPhone ?? "",
			CommercialEmail:
				payload?.commercialEmail ?? payload?.CommercialEmail ?? "",
			SupportPhone: payload?.supportPhone ?? payload?.SupportPhone ?? "",
			SupportEmail: payload?.supportEmail ?? payload?.SupportEmail ?? "",
			SupportWhatsApp:
				payload?.supportWhatsApp ?? payload?.SupportWhatsApp ?? "",
			ApiKey: payload?.apiKey ?? payload?.ApiKey ?? "",
		};

		let response = await api.post(basePath, JSON.stringify(requestPayload));
		let treated = errorHandling.handleResponse(
			response,
			"supplierService.create"
		);
		if (treated) {
			return { data: treated, status: response.status };
		}
		return null;
	} catch (error) {
		errorHandling.cathError(error, "supplierService.create");
		return null;
	}
}

async function update(payload) {
	try {
		const requestPayload = {
			SupplierId: payload?.supplierId ?? payload?.SupplierId ?? payload?.id ?? 0,
			SupplierName: payload?.supplierName ?? payload?.SupplierName ?? "",
			CommercialContactName:
				payload?.commercialContactName ?? payload?.CommercialContactName ?? "",
			CommercialPhone:
				payload?.commercialPhone ?? payload?.CommercialPhone ?? "",
			CommercialEmail:
				payload?.commercialEmail ?? payload?.CommercialEmail ?? "",
			SupportPhone: payload?.supportPhone ?? payload?.SupportPhone ?? "",
			SupportEmail: payload?.supportEmail ?? payload?.SupportEmail ?? "",
			SupportWhatsApp:
				payload?.supportWhatsApp ?? payload?.SupportWhatsApp ?? "",
			ApiKey: payload?.apiKey ?? payload?.ApiKey ?? "",
		};

		let response = await api.put(basePath, JSON.stringify(requestPayload));
		let treated = errorHandling.handleResponse(
			response,
			"supplierService.update"
		);
		if (treated) {
			return treated;
		}
		return null;
	} catch (error) {
		errorHandling.cathError(error, "supplierService.update");
		return null;
	}
}

async function save(payload) {
	if (payload.id > 0) {
		const updated = await update(payload);

		if (typeof updated === "number") {
			return { id: updated, isCreated: false };
		}

		const updatedId =
			updated?.SupplierId ??
			updated?.supplierId ??
			updated?.id ??
			updated?.resourceId ??
			payload?.id ??
			null;

		return { id: updatedId, isCreated: false };
	}

	const created = await create(payload);

	if (!created) {
		return null;
	}

	if (typeof created === "number") {
		return { id: created, isCreated: true };
	}

	const createdData = created?.data || created;
	const isCreated = created?.status === 201;

	const createdId =
		createdData?.SupplierId ??
		createdData?.supplierId ??
		createdData?.id ??
		createdData?.resourceId ??
		null;

	return { id: createdId, isCreated };
}

async function list(payload = {}) {
	try {
		const queryParams = new URLSearchParams();

		const supplierId = payload?.SupplierId ?? payload?.supplierId ?? payload?.id;
		const active = payload?.Active ?? payload?.active;

		if (supplierId !== undefined && supplierId !== null && supplierId !== "") {
			queryParams.append("SupplierId", supplierId);
		}

		if (active !== undefined && active !== null && active !== "") {
			queryParams.append("Active", active);
		}

		const queryString = queryParams.toString();
		const url = queryString ? `${basePath}?${queryString}` : basePath;

		let response = await api.get(url);
		let treated = errorHandling.handleResponse(response, "supplierService.list");
		if (treated) {
			return treated;
		}
		return null;
	} catch (error) {
		errorHandling.cathError(error, "supplierService.list");
		return null;
	}
}

async function remove(supplierId) {
	try {
		let response = await api.delete(`${basePath}/${supplierId}`);
		let treated = errorHandling.handleResponse(
			response,
			"supplierService.remove"
		);
		if (treated) {
			if (typeof treated === "number") {
				return treated;
			}

			return (
				treated?.SupplierId ??
				treated?.supplierId ??
				treated?.id ??
				treated?.resourceId ??
				null
			);
		}
		return null;
	} catch (error) {
		errorHandling.cathError(error, "supplierService.remove");
		return null;
	}
}

export const supplierService = {
	list,
	save,
	update,
	remove,
};
